module.exports = __webpack_public_path__ + "static/vertical_turbine-c899716b21578c99f7f8fd0ebd65387e.png";